import AdminUsersModeration from "../Components/AdminUsersModeration";
import { usePermissionCheck } from "../hooks/usePermissionCheck";

export default function AdminUsers() {
  const { loading, allowed } = usePermissionCheck("Users.View");

  if (loading) {
    return <div className="workspace-panel rounded-2xl p-8 text-center text-sm text-slate-600">Yetkiler kontrol ediliyor...</div>;
  }

  if (!allowed) {
    return <div className="admin-soft-alert text-sm">Bu sayfaya erişim izniniz yok.</div>;
  }

  return (
    <div className="space-y-4">
      <section className="workspace-panel rounded-2xl p-4">
        <h2 className="text-lg font-bold text-slate-900">Kullanıcı 360 Moderasyon</h2>
        <p className="text-sm text-slate-600">
          Kullanıcı arama, segment bazlı filtreleme, ban/rol işlemleri ve audit takibini bu merkezden yönetebilirsiniz.
        </p>
      </section>

      <AdminUsersModeration />
    </div>
  );
}
